// extracted by mini-css-extract-plugin
module.exports = {"myCol":"TiposPosturas__myCol__2zf0-"};